import PreviewNext from './PreviewNext';
import caseTransitionBehavior from './caseTransitionBehavior';

export default caseTransitionBehavior(PreviewNext, 'case');



// WEBPACK FOOTER //
// ./src/components/PreviewNextCase.js